import * as React from 'react';
const OptionCardFooterCore = (props) => {
    const { components: { CardFooter }, children, } = props;
    return React.createElement(CardFooter, { className: "option-card__footer" }, children);
};
export default OptionCardFooterCore;
